/* The structured data of one blog post: BlogPosting, BreadcrumbList and,
   when the post has one, FAQPage.

   Shared by BlogPost.jsx (Helmet) and scripts/prerender.cjs (static HTML)
   so a crawler that never runs JavaScript (GPTBot, ClaudeBot,
   PerplexityBot) and one that does read the same graph. The author and
   publisher point at the ids joseamijares.com and index.html publish, so
   the three records merge into one entity.

   `image` lists the cover first, then every figure in the body as an
   ImageObject with its alt text and caption (scripts/build-blog.cjs
   collects them into post.figures), so an answer engine can tell what each
   illustration explains without looking at it. */

const SITE = 'https://jamaklab.com';
const absolute = (src) => (src.startsWith('http') ? src : `${SITE}${src}`);

export function blogPostSchema(post, { url, lang, breadcrumbs }) {
  const authorName = post.author?.name || 'JAMAK';
  const images = [
    ...(post.featuredImage
      ? [{ '@type': 'ImageObject', url: absolute(post.featuredImage), ...(post.featuredImageSize || {}),
           ...(post.featuredImageAlt ? { description: post.featuredImageAlt } : {}) }]
      : []),
    ...(post.figures || []).map((figure) => ({
      '@type': 'ImageObject',
      url: absolute(figure.src),
      ...(figure.width ? { width: figure.width, height: figure.height } : {}),
      ...(figure.alt ? { description: figure.alt } : {}),
      ...(figure.caption ? { caption: figure.caption } : {}),
    })),
  ];
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.title,
      description: post.excerpt,
      ...(images.length ? { image: images } : {}),
      author: /Mijares/.test(authorName)
        ? { '@type': 'Person', '@id': 'https://joseamijares.com/#person', name: authorName, url: 'https://joseamijares.com/' }
        : { '@type': 'Person', name: authorName },
      publisher: { '@id': `${SITE}/#organization` },
      datePublished: post.publishedAt,
      dateModified: post.modifiedAt || post.publishedAt,
      mainEntityOfPage: url,
      inLanguage: lang === 'es' ? 'es-MX' : 'en-US',
      articleSection: post.category,
      keywords: (post.seoKeywords || post.tags || []).join(', '),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((crumb, index) => ({
        '@type': 'ListItem', position: index + 1, name: crumb.name, item: crumb.url,
      })),
    },
    ...(post.faqSchema?.length
      ? [{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: post.faqSchema.map((f) => ({
            '@type': 'Question', name: f.question, acceptedAnswer: { '@type': 'Answer', text: f.answer },
          })),
        }]
      : []),
  ];
}
